import { useState, useEffect } from 'react'
import { PageHeader, StatusBadge, EmptyState } from '../components/UI'
import { get, post } from '../utils/api'
import { formatCurrency, formatDate } from '../utils/helpers'
import { IconPlus, IconFileCertificate, IconPencil, IconCopy, IconCheck } from '@tabler/icons-react'

export default function ContractsPage() {
  const [contracts, setContracts] = useState([])
  const [loading, setLoading] = useState(true)

  const load = () => get('/contracts').then(setContracts).catch(() => {}).finally(() => setLoading(false))
  useEffect(() => { load() }, [])

  const sendForSignature = async (id) => {
    try {
      const data = await post(`/public/sign-contract/${id}`)
      navigator.clipboard?.writeText(data.sign_url)
      alert('E-sign link copied to clipboard! Send it to the client.')
      load()
    } catch (err) { alert(err.message) }
  }

  const copySignUrl = (c) => {
    if (c.signature_token) {
      const url = `${window.location.origin}/public/contract/${c.signature_token}`
      navigator.clipboard?.writeText(url)
      alert('Link copied!')
    }
  }

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary" /></div>

  return (
    <>
      <PageHeader title="Contracts" subtitle={`${contracts.length} contracts`}
        actions={<button className="btn btn-primary btn-sm"><IconPlus size={16} className="me-1" />New Contract</button>} />

      <div className="row row-cards mb-3">
        {[{ l: 'Total', v: contracts.length },
          { l: 'Signed', v: contracts.filter(c => c.status === 'signed').length },
          { l: 'Awaiting Signature', v: contracts.filter(c => c.status === 'sent').length },
          { l: 'Total Value', v: formatCurrency(contracts.reduce((s, c) => s + parseFloat(c.amount || 0), 0)) }
        ].map(s => (
          <div key={s.l} className="col-6 col-lg-3"><div className="card stat-mini"><div className="card-body">
            <div className="subheader">{s.l}</div><div className="h3 mb-0">{s.v}</div>
          </div></div></div>
        ))}
      </div>

      {contracts.length === 0 ? <EmptyState icon={IconFileCertificate} title="No contracts" /> : (
        <div className="card">
          <div className="table-responsive">
            <table className="table table-vcenter card-table table-hover">
              <thead><tr><th>Title</th><th>Company</th><th>Contact</th><th>Amount</th><th>Status</th><th>Signed</th><th>Actions</th></tr></thead>
              <tbody>{contracts.map(c => (
                <tr key={c.id}>
                  <td className="fw-medium">{c.title}</td><td>{c.company}</td><td>{c.contact_name}</td>
                  <td className="fw-bold">{formatCurrency(c.amount)}</td>
                  <td><StatusBadge status={c.status} />
                    {c.signer_name && <div className="text-secondary" style={{ fontSize: '0.7rem' }}>by {c.signer_name}</div>}
                  </td>
                  <td>{c.signed_date ? formatDate(c.signed_date, { month: 'short', day: 'numeric' }) : '---'}</td>
                  <td>
                    <div className="d-flex gap-1">
                      {c.status === 'signed' ? (
                        <span className="badge bg-green-lt"><IconCheck size={14} className="me-1" />Signed</span>
                      ) : (
                        <>
                          <button className="btn btn-primary btn-sm" onClick={() => sendForSignature(c.id)} title="Generate e-sign link">
                            <IconPencil size={14} className="me-1" />E-Sign
                          </button>
                          {c.signature_token && <button className="btn btn-outline-secondary btn-sm btn-icon" onClick={() => copySignUrl(c)} title="Copy sign link"><IconCopy size={14} /></button>}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}
